import { render, staticRenderFns } from "./ViewGroup.vue?vue&type=template&id=1e62b63d"
import script from "./ViewGroup.vue?vue&type=script&lang=js"
export * from "./ViewGroup.vue?vue&type=script&lang=js"
import style0 from "./ViewGroup.vue?vue&type=style&index=0&id=1e62b63d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports